import { Button, type ButtonProps, CircularProgress } from "@mui/material";
import type { FC } from "react";

type Props = ButtonProps & { loading?: boolean };

export const LoadingButton: FC<Props> = ({
	loading = false,
	disabled,
	children,
	...rest
}) => (
	<Button {...rest} disabled={disabled || loading}>
		{loading ? (
			<CircularProgress size={20} sx={{ color: "inherit" }} />
		) : (
			children
		)}
	</Button>
);
